export const firmaReglas = (reglas) =>
    (reglas || [])
        .map(function(r) {
            var anio = r.regla === 'garantia' && r.anio_garantia ? String(r.anio_garantia) : '';
            return r.regla + ':' + anio;
        })
        .join('|');

export const estadoInicialDesdePrograma = (programa) => {
    var tiposSeleccionados = {};
    var presupuestos = {};
    var reglasPorTipo = {};
    var firmasOriginales = {};

    (programa.tipos || []).forEach(function(t) {
        var id = t.modelo_tipo_id;
        tiposSeleccionados[id] = true;
        presupuestos[id] = t.presupuesto_referencia !== null && t.presupuesto_referencia !== undefined
            ? String(parseFloat(t.presupuesto_referencia))
            : '';
        reglasPorTipo[id] = (t.reglas || []).map(function(r) {
            return { key: r.regla, anioGarantia: r.anio_garantia ? String(r.anio_garantia) : '' };
        });
        firmasOriginales[id] = firmaReglas(t.reglas);
    });

    return {
        formData: {
            nombre: programa.nombre || '',
            fecha_inicio: programa.fecha_inicio || '',
            fecha_fin: programa.fecha_fin || '',
            fecha_limite_publicacion: programa.fecha_limite_publicacion || '',
        },
        tiposSeleccionados: tiposSeleccionados,
        presupuestos: presupuestos,
        reglasPorTipo: reglasPorTipo,
        firmasOriginales: firmasOriginales,
    };
};

export const tiposARegenerar = (firmasOriginales, tiposInput) =>
    tiposInput
        .filter(function(t) {
            var original = firmasOriginales[t.modelo_tipo_id];
            return original === undefined || original !== firmaReglas(t.reglas);
        })
        .map(function(t) { return t.modelo_tipo_id; });

export const tiposQuitados = (firmasOriginales, tiposInput) => {
    var actuales = tiposInput.map(function(t) { return t.modelo_tipo_id; });
    return Object.keys(firmasOriginales)
        .map(function(id) { return parseInt(id, 10); })
        .filter(function(id) { return actuales.indexOf(id) === -1; });
};

export const cambiaLaGrilla = (firmasOriginales, tiposInput) =>
    tiposARegenerar(firmasOriginales, tiposInput).length > 0 || tiposQuitados(firmasOriginales, tiposInput).length > 0;

export const formatearValorEdicion = (campo, valor, etiquetaRegla) => {
    if (valor === null || valor === undefined || valor === '') return '—';
    if (campo === 'reglas') {
        if (!Array.isArray(valor) || valor.length === 0) return '—';
        return valor
            .map(function(r) {
                var etiqueta = etiquetaRegla ? etiquetaRegla(r.regla) : r.regla;
                return r.anio_garantia ? etiqueta + ' (' + r.anio_garantia + ')' : etiqueta;
            })
            .join(' > ');
    }
    if (Array.isArray(valor)) return valor.length ? valor.join(', ') : '—';
    return String(valor);
};
